import { Action } from "../action";
import { Price } from "../price";
import { Research } from "../research";

export class TeamAction extends Action {
  teamRes: Research;

  constructor(prices: Price[]) {
    super("T", "团队合作", "得到更好的团队合作加成", prices);
    this.autoBuyPriceMulti = 1.5;
    this.autoBuyTimeMulti = 1.5;
  }

  reload() {
    if (this.teamRes.done) {
      super.reload();
    } else {
      this.canBuy = false;
      // this.maxBuy = new Decimal(0);
    }
  }
}
